<script setup lang="ts">
import BuilderHeader from "@/components/common/BuilderHeader.vue";
import FormBuilderLeftSidebar from "@/components/common/BuilderLeftSidebar.vue";
import NotificationsView from "@/components/common/Notifications/NotificationsView.vue";
import SecondaryHeader from "@/components/common/SecondaryHeader.vue";
import SettingsView from "@/components/common/Settings/SettingsView.vue";
import FormbuilderSidebar from "@/components/common/Sidebar/RightSidebar.vue";
import SubmissionsView from "@/components/common/Submissions/SubmissionsView.vue";
import AnalyticsView from "@/components/common/Analytics/AnalyticsView.vue";
import IntegrateView from "@/components/common/Integrate/IntegrateView.vue";
import VersionHistory from "@/components/common/VersionHistory.vue";
import FormbuilderPreview from "@/components/forms/FormbuilderPreview.vue";
import { MediaCenterSubCategory } from "@/helpers/mediaCenter.type";
import { useAppStore } from "@/store/app";
import { PRODUCT_TYPE } from "@/util/constants";
import { UISpin } from "@gohighlevel/ghl-ui";
import { computed, onMounted, onUnmounted } from "vue";

const store = useAppStore();

// Computed to determine which component to show based on active tab
const showContentComponent = computed(() => {
  if (!store.isNewBuilderLayoutEnabled) {
    return "preview"; // Always show preview in old layout
  }
  return store.activeBuilderTab;
});

// const preventNav = (event) => {
//   if (!store.anyUnsavedChanges) {
//     return;
//   }
//   event.preventDefault();
//   event.returnValue = "";
// };
// onBeforeMount(() => {
//   window.addEventListener("beforeunload", preventNav);
// });

// onBeforeUnmount(() => {
//   window.removeEventListener("beforeunload", preventNav);
// });

onMounted(() => {
  store.mediaCenterSubCategory = MediaCenterSubCategory.FORM;
});

onUnmounted(() => {
  store.mediaCenterSubCategory = null;
});
</script>

<template>
  <div v-if="!store.showVersions">
    <section class="builder-container">
      <BuilderHeader id="builder-header" />
      <SecondaryHeader id="secondary-builder-header" />
      <div v-if="store.processing" class="loader-container">
        <UISpin />
      </div>
      <div v-else id="builder-inner-container" class="h-full">
        <FormBuilderLeftSidebar :builder-type="PRODUCT_TYPE.FORM" />

        <!-- Conditional rendering based on active tab -->
        <FormbuilderPreview
          v-if="showContentComponent === 'edit' || showContentComponent === 'preview'"
        />
        <SettingsView v-else-if="showContentComponent === 'settings'" />
        <IntegrateView v-else-if="showContentComponent === 'integrate'" />
        <SubmissionsView v-else-if="showContentComponent === 'submissions'" />
        <NotificationsView
          v-else-if="showContentComponent === 'notifications'"
          :builder-type="PRODUCT_TYPE.FORM"
        />
        <AnalyticsView v-else-if="showContentComponent === 'analytics'" />

        <FormbuilderSidebar />
      </div>
    </section>
  </div>
  <div v-else><VersionHistory /></div>
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");

.builder-container {
  height: 100vh;
  overflow: hidden;
}
#builder-inner-container {
  position: relative;
  top: 0;
  height: inherit;
}
#builder-header {
  position: fixed;
  width: 100%;
  z-index: 1000;
}
.sidebar-right {
  position: fixed;
  right: 0;
  top: 52px;
  width: 100%;
  max-width: 300px;
  background-color: #ffffff;
  border: 1px solid #dee2e6 !important;
  height: 100%;
}
.loader-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(0, -50%);
}
body {
  min-height: 100%;
  height: 100%;
  background-color: #f3f4f6 !important;
}

.label-maker {
  font-size: 0.8rem;
}

.text-gray-700 {
  --tw-text-opacity: 0.8;
}
.line-form-style {
  background: #ffffff !important;
  border: none !important;
  border-bottom: 1px solid #000000;
  border-radius: 0 !important;
}
</style>
